export const northProposal = {
  slug: "north",
  clientName: "North",
  accessEnvKey: "VITE_PROPOSAL_NORTH_ACCESS_CODE",
  comedyuoLogo: "/comedyuo-logo-white.png",
  heroImage: "https://storage.googleapis.com/cuo-website/Best+Comedy+Shows+.jpg",
  heroImageAlt: "A packed crowd at a ComedyUO show",
  contactName: "Mike Zbyszewski",
  contactRole: "Sales & Partnerships, ComedyUO",
  contactEmail: "mike@comedyuo.com",
  contactPhone: "(310) 469-8961",
} as const;
